module.exports = __webpack_public_path__ + "static/media/EnterMobileBG.70b64859.mp4";